import React from "react";
import { bool, func, string } from "prop-types";
import Base64Downloader from "react-base64-downloader";
import Button from "pages/_components/Button";
import CustomText from "pages/_components/CustomText/CustomText";
import Loader from "pages/_components/Loader";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import Container from "pages/_components/Container";
import { Col } from "react-bootstrap";
import { ResponsiveHeader } from "pages/_components/header";
import { useDispatch } from "react-redux";
import { getDisplay } from "util/device";
import { isIOS } from "react-device-detect";
import * as i18nUtils from "util/i18n";
import { actions as notificationActions } from "reducers/notification";
import Notification from "pages/_components/Notification";

const QRImage = ({ qrImage, toggleQr, isDesktop }) => {
    const dispatch = useDispatch();
    const handleClickShareQr = () => {
        toggleQr({ qrIsVisible: false });
    };

    const handleClickDownloadQr = () => {
        toggleQr({ qrIsVisible: false });
        dispatch(
            notificationActions.showNotification(i18nUtils.get("account.detail.qr.download.success"), "success", [
                "account/details",
            ]),
        );
    };
    const handleClickDownloadQrError = () => {
        toggleQr({ qrIsVisible: false });
    };

    if (!qrImage.length) {
        return <Loader />;
    }

    return (
        <>
            <Notification scopeToShow="account/qr/page" />
            {getDisplay() === "mobile" ? <ResponsiveHeader id="accounts.details.qrCode" /> : null}
            <Container className="container height-100">
                <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3} className="text-left height-100">
                    {isDesktop ? (
                        <h2 className="title-content">
                            <CustomText text="accounts.details.qrCode" textType="I18N" />
                        </h2>
                    ) : null}
                    <div className="drawer-wrapper height-80">
                        <div>
                            <CustomText
                                text={
                                    isDesktop ? "accounts.details.qrDescription.web" : "accounts.details.qrDescription"
                                }
                                textType="I18N"
                            />
                            <div className="qr-code">
                                <img src={qrImage} alt="qr" className="qr" height="300px" width="300px" />
                            </div>
                        </div>
                        <div className="row">
                            {!isDesktop && (
                                <Button
                                    className="btn btn-outline"
                                    image="images/figma/icon/share.svg"
                                    label="global.share"
                                    onClick={() => {
                                        if (!isDesktop && window.cordova) {
                                            const options = {
                                                files: [qrImage],
                                            };
                                            window.plugins.socialsharing.shareWithOptions(options, null, null);
                                        } else {
                                            handleClickShareQr();
                                        }
                                    }}
                                />
                            )}
                            {!isIOS ? (
                                <Base64Downloader
                                    base64={qrImage}
                                    downloadName="QR-Image"
                                    Tag="a"
                                    extraAttributes={{ href: "#" }}
                                    className="btn-primary  btn btn-default btn-block"
                                    onDownloadSuccess={handleClickDownloadQr}
                                    onDownloadError={handleClickDownloadQrError}>
                                    <Image src="images/figma/icon/download.svg" className="svg-icon" />
                                    <I18n id="global.download" />
                                </Base64Downloader>
                            ) : (
                                <Button
                                    className="btn-primary"
                                    image="images/figma/icon/download.svg"
                                    label="global.download"
                                    onClick={() => {
                                        if (!isDesktop && window.cordova) {
                                            window.plugins.socialsharing.saveToPhotoAlbum([qrImage], null, null);
                                            dispatch(
                                                notificationActions.showNotification(
                                                    i18nUtils.get("account.detail.qr.download.success"),
                                                    "success",
                                                    ["account/qr/page"],
                                                ),
                                            );
                                        }
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </Col>
            </Container>
        </>
    );
};

QRImage.propTypes = {
    qrImage: string.isRequired,
    toggleQr: func.isRequired,
    isDesktop: bool.isRequired,
};

export default QRImage;
